// @flow
export type SignUpLoginActionType =
  | {|
      type: 'SIGNUP_SET_LOGIN',
      payload: {|
        email: string,
        password: string,
        optionExternalCommercial?: boolean,
        optionInternalCommercial?: boolean,
      |},
    |}
  | {|
      type: 'SIGNUP_SET_VALIDATION_CODE',
      payload: {|
        validationCode: ?string,
      |},
    |};

export function setLogin({
  email,
  password,
  optionExternalCommercial,
  optionInternalCommercial,
}: {
  email: string,
  password: string,
  optionExternalCommercial?: boolean,
  optionInternalCommercial?: boolean,
}): SignUpLoginActionType {
  return {
    type: 'SIGNUP_SET_LOGIN',
    payload: {
      email,
      password,
      optionExternalCommercial,
      optionInternalCommercial,
    },
  };
}

export const setValidationCode = (validationCode: ?string): SignUpLoginActionType => ({
  type: 'SIGNUP_SET_VALIDATION_CODE',
  payload: {
    validationCode,
  },
});
